import React, { useEffect, useRef } from 'react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styles from './EditorExtension_AlbumViewer.module.css';
import { useCCContext } from '../CC/CCContext';
import {CC} from '../CC/CC';
import * as ccUtils from '../CC/utils';
import { generateQuery, postWithCache } from '../CC/utils';
import AlbumViewer from './AlbumViewer';

export default Node.create({
  name: 'reactComponentAlbumViewer',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      selected: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-selected') === 'true',
        renderHTML: (attributes) => ({
          'data-selected': attributes.selected
        }),
      },
      albumSource: {
        default: '',
        parseHTML: (element) => {
          const albumSource = element.getAttribute('data-albumSource');
          return albumSource;
        },
        renderHTML: (attributes) => ({
          'data-albumSource': attributes.albumSource
        }),
      },
      isEditorMode: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-is-editor-mode') === 'true',
        renderHTML: (attributes) => ({
          'data-is-editor-mode': attributes.isEditorMode
        }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'AlbumViewer',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ['AlbumViewer', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
})

const Component = (props) => {
  const ctx = useCCContext();
  const { cc, setCc, first, setFirst, recordsPerPage, setRecordsPerPage, viewMode, setViewMode, browseMode, setBrowseMode, data, setData, isReady, clearSearch } = useCCContext();
  const { selected, updateAttributes } = props;
  const { albumSource, isEditorMode } = props.node.attrs;
  const componentRef = useRef({});
  const rootRef = useRef(null);

  useEffect(() => {
    const handleSelection = () => {
      updateAttributes({ selected: props.editor.isActive('reactComponentAlbumViewer') });
    };
    props.editor.on('selectionUpdate', handleSelection);
    return () => {
      props.editor.off('selectionUpdate', handleSelection);
    };
  }, [props.editor, updateAttributes]);

  const handleClick = (event) => {
    if (props.editor.isEditable) {
      event.stopPropagation();
      alert('editor');
    } else {
      alert('viewer');
    }
  };

  useEffect(() => {
    const rootElement = rootRef.current;
    if (rootElement) {
      rootElement.addEventListener('click', handleClick, true);
      return () => {
        rootElement.removeEventListener('click', handleClick, true);
      };
    }
  }, [isEditorMode]);

  console.log('albumSource', albumSource);

  return (
    <NodeViewWrapper as="span" className={`react-component ${selected ? 'selected' : ''}`} ref={rootRef}>
      <span className={styles.hyperlink}>
        <AlbumViewer albumSource={albumSource} isEditorMode={isEditorMode} />
      </span>
    </NodeViewWrapper>
  );
}